import { Col, Row } from "reactstrap";

//images
import Verifikasi1 from '../../assets/images/home/modal/verifikasi-1.png';
import Verifikasi2 from '../../assets/images/home/modal/verifikasi-2.png';
import Verifikasi3 from '../../assets/images/home/modal/verifikasi-3.png';
import Verifikasi4 from '../../assets/images/home/modal/verifikasi-4.png';
import Verifikasi5 from '../../assets/images/home/modal/verifikasi-5.png';
import Verifikasi6 from '../../assets/images/home/modal/verifikasi-6.png';
import Verifikasi7 from '../../assets/images/home/modal/verifikasi-7.png';
import Verifikasi8 from '../../assets/images/home/modal/verifikasi-8.png';

const Verifikasi = () => {
  return(
    <>
      <Row>
        <Col md="1"></Col>
        <Col md="10" className="text-center modal-home">
          <h6 className="mb-3">
            COBA VERIFIKASI INFORMASI DULU
          </h6>
          <p>
            Yay! kamu berhasil <strong>memilih</strong> pilihan <strong>tindakan terbaik</strong> menanggapi persoalan di atas.
          </p>
          <p>
            Sebagai pengguna aktif media sosial, kita wajib cek dan waspada informasi yang kita terima.
          </p>
          <p>
            Berikut proses verifikasi yang bisa kamu lakukan:
          </p>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi1} alt="verifikasi-1"/>
            <p className="mx-2">Baca informasi atau berita secara menyeluruh.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi2} alt="verifikasi-2" />
            <p className="mx-2">Cek sumber. Apakah penulis dan berita berasal dari media kredibel atau tidak.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi3} alt="verifikasi-3" />
            <p className="mx-2">Jika merasa ragu, jangan dibagikan ke kerabat lain. </p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi4} alt="verifikasi-4" />
            <p className="mx-2">Periksa bukti yang dituliskan dalam postingan atau artikel.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi5} alt="verifikasi-5" />
            <p className="mx-2">Jangan mudah percaya terhadap foto atau video yang beredar.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi6} alt="verifikasi-6" />
            <p className="mx-2">Kamu bisa cek fakta mandiri atau menanyakannya pada ahli.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi7} alt="verifikasi-7" />
            <p className="mx-2">Jika terbukti benar, tentukan apakah berita tersebut memiliki manfaat yang baik jika kamu sebar.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Verifikasi8} alt="verifikasi-8" />
            <p className="mx-2">Jika terbukti hoaks, kamu bisa melaporkannya ke platform tempat  hoaks  tersebut dibuat atau pihak yang menangani hoaks.</p>
          </div>
          <p className="mt-3">
            Note:<br/>
            Kamu bisa mengetahui kebenaran klaim Chat Tante Rajit melalui permainan Nitijana Game.
          </p>
        </Col>
        <Col md="1"></Col>
      </Row>
    </>
  );
}

export default Verifikasi